import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Stethoscope } from 'lucide-react';
import { useFormModal } from './FormModal';
export function OfferSection() {
  const {
    openFormModal
  } = useFormModal();
  return <section className="py-10 lg:py-20 bg-white" data-id="element-160">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="text-center mb-8 lg:mb-12" data-id="element-162">
          <h2 className="text-3xl md:text-4xl font-light text-brand-dark mb-3 lg:mb-4" data-id="element-163">
            Your Invisalign Offer
          </h2>
          <p className="text-lg text-brand-dark/60" data-id="element-164">
            Limited-time promotion for Miami Lakes, Hialeah & Doral residents.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 lg:gap-10 mb-8 lg:mb-12" data-id="element-165">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-brand-dark rounded-2xl p-5 lg:p-8 relative overflow-hidden" data-id="element-166">
            <div className="w-12 h-12 lg:w-14 lg:h-14 bg-white/10 rounded-full flex items-center justify-center mb-4 lg:mb-6" data-id="element-167">
              <Stethoscope className="w-6 h-6 lg:w-7 lg:h-7 text-white/70" data-id="element-168" />
            </div>
            <h3 className="text-xl lg:text-2xl font-medium text-white mb-2 lg:mb-3" data-id="element-169">
              Free Consultation
            </h3>
            <p className="text-white/60 text-sm lg:text-base" data-id="element-170">
              Meet with Dr. Lima to discuss your goals, get a 3D scan of your
              smile, and see a preview of your results. No commitment required.
            </p>
            <div className="mt-4 lg:mt-6 inline-block bg-white/10 text-white/60 px-3 py-1 rounded-full text-xs lg:text-sm font-medium" data-id="element-171">
              Value: $250
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-brand-dark rounded-2xl p-5 lg:p-8 relative overflow-hidden border border-brand-cream/20" data-id="element-172">
            <div className="w-12 h-12 lg:w-14 lg:h-14 bg-brand-cream/10 rounded-full flex items-center justify-center mb-4 lg:mb-6" data-id="element-173">
              <Gift className="w-6 h-6 lg:w-7 lg:h-7 text-brand-cream" data-id="element-174" />
            </div>
            <h3 className="text-xl lg:text-2xl font-medium text-white mb-2 lg:mb-3" data-id="element-175">
              $3,000 Off Treatment
            </h3>
            <p className="text-white/60 text-sm lg:text-base" data-id="element-176">
              Receive a massive $3,000 discount on your comprehensive Invisalign
              treatment plan when you start your journey with us.
            </p>
            <div className="mt-4 lg:mt-6 inline-block bg-brand-cream/20 text-brand-cream px-3 py-1 rounded-full text-xs lg:text-sm font-medium" data-id="element-177">
              Limited Time Only
            </div>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-178">
          <button onClick={openFormModal} className="bg-brand-dark hover:bg-brand-darkAlt text-white font-medium py-4 px-10 rounded-full transition-colors text-lg" data-id="element-179">
            Claim Both Offers Now
          </button>
        </div>
      </div>
    </section>;
}